import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { QrCode, Download } from "lucide-react";

export const LeadLinkQR = ({ url, name, label = "QR Code", triggerVariant = "outline", triggerClass = "", testid = "qr-btn" }) => {
  const ref = useRef(null);
  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${(name || "lead").replace(/\s+/g, "_")}_lead_qr.png`;
    a.click();
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant={triggerVariant} size="sm" className={triggerClass} data-testid={testid}>
          <QrCode size={16} className="mr-2" />{label}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>Lead Form QR{name ? ` — ${name}` : ""}</DialogTitle></DialogHeader>
        <div className="flex flex-col items-center gap-4 pt-2" ref={ref}>
          <div className="bg-white p-4 rounded-xl border border-slate-200"><QRCodeCanvas value={url} size={220} level="M" includeMargin /></div>
          <p className="text-xs text-slate-500 break-all text-center">{url}</p>
          <Button onClick={download} className="bg-[#0F4C81] hover:bg-[#0A3A66]" data-testid="qr-download-btn"><Download size={16} className="mr-2" />Download PNG</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
